import { useCallback, useState } from 'react';
import { useApartmentCountLimits } from '../../interface_adapters/hooks/ApartmentCountLimitsContext';
import { validateApartmentCount } from '../../presentation/pages/Flow/ApartmentCount/apartmentCountUtils';

export const useApartmentCount = (initialCount: number) => {
  const limits = useApartmentCountLimits();
  const [apartmentCount, setApartmentCount] = useState<number>(initialCount);
  const [isApartmentCountExceededModalOpen, setApartmentCountExceededModalOpen] =
    useState<boolean>(false);

  const increaseCount = useCallback(() => {
    setApartmentCount((currentCount) => {
      const newCount = currentCount + 1;
      if (newCount > limits.getMax()) {
        setApartmentCountExceededModalOpen(true);
        return currentCount;
      }
      return newCount;
    });
  }, [limits]);

  const decreaseCount = useCallback(() => {
    setApartmentCount((currentCount) => Math.max(currentCount - 1, limits.getMin()));
  }, [limits]);

  const handleCountChange = useCallback((newCount: number) => {
    setApartmentCount(newCount);
  }, []);

  const handleBlur = useCallback(
    (newCount: number) => {
      setApartmentCountExceededModalOpen(newCount > limits.getMax());

      const validCount = validateApartmentCount(newCount, limits.getMin(), limits.getMax());
      setApartmentCount(validCount);
      //TODO: Handle the case where the count is smaller than MIN_APARTMENT_COUNT
    },
    [limits]
  );

  return {
    apartmentCount,
    isApartmentCountExceededModalOpen,
    setApartmentCountExceededModalOpen,
    increaseCount,
    decreaseCount,
    handleCountChange,
    handleBlur
  };
};
